var exports = {
  "k": "AppearanceTabInline.module__container___N3Fvbn",
};

module.exports = exports;
